import { createApp} from "vue";
import App from "./App.vue";

document.addEventListener('DOMContentLoaded', () => {
  //描画先が無い(=ログインしていない)場合はなにもしない
  if ( ! document.getElementById('post-app')) {
    return;
  }

  //ログインしていれば描画
  const app = createApp(App);
  app.mount('#post-app');
});
